import { Box, Button, Flex, Text } from '@chakra-ui/react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'
import { pluralize } from '@/utils/helpers'

import TopicQ from '@/queries/TopicQ'
import UserQ from '@/queries/UserQ'
import { useUser } from '@/client/context/user'
import type { Query } from '@/client/query'
import { getTranscriptUrlByUUID } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import UserAvatar from '@/components/UserAvatar'

export default function TutorCertificationCard({ tutor }: { tutor: Query }): JSX.Element {
  const currentUser = useUser()
  const tutorId = tutor(UserQ.id)
  const uuidTranscript = tutor(UserQ.uuid_transcript)
  const isCurrentUser = tutorId === currentUser.id
  const displayName = tutor(UserQ.display_name)
  const avatarUrl = tutor(UserQ.avatar_url) ?? ''
  const firstName = tutor(UserQ.first_name)
  const progressionLevel = tutor(UserQ.progression_level)

  const numberOfCertifications = tutor`COUNT(*)
        ${TopicQ.getCertifiedTopics({ userId: UserQ.id, reviewed: 'approved' })}
    `

  return (
    <Box
      as="a"
      color="inherit"
      textDecoration="none"
      backgroundColor="bg"
      width="100%"
      borderRadius="8px"
      border={`2px solid ${chakraTokenToVar('border')}`}
    >
      <Flex backgroundColor="bg.muted" justifyContent="center" borderTopRadius="8px" height="99px">
        <UserAvatar
          src={avatarUrl}
          name={`${displayName}`}
          size="2xl"
          position="relative"
          top="32px"
          progressionLevel={progressionLevel}
        />
      </Flex>
      <Flex direction="column" mt="72px" px="16px" mb="24px" alignItems="center">
        <Text mb="8px" fontWeight="bold" fontSize="large" textAlign="center">
          {`${displayName}${isCurrentUser ? ' (you)' : ''}`}
        </Text>
        <Text mb="26px" color="fg.muted" fontWeight="semibold" fontSize="small" textAlign="center">
          {pluralize(numberOfCertifications ?? 0, 'Topic')} Certified
        </Text>
        <ShwLink href={getTranscriptUrlByUUID(uuidTranscript ?? '')}>
          <Button variant="outline" width={['100%', 'auto']}>
            View {firstName}&apos;s Portfolio
          </Button>
        </ShwLink>
      </Flex>
    </Box>
  )
}
